// extracted by mini-css-extract-plugin
export default {"products":"IA-z","card":"JA-z","oosMessaging":"KA-z"};